module.exports = __webpack_public_path__ + "static/DSC_9517-fc8ea831409cdb2958728eea259ab479.jpg";